// src/utils/avatarTint.js
//
// Picks one of the shared `.avatar--tN` tint classes defined in index.css.
//
// Deterministic on the name so a given patient keeps the same colour between
// visits and between screens (a patient who is blue in the list is blue in
// their appointment row too). Replaces the hardcoded six-hex palette that used
// to live in the doctor portal's private stylesheet — tints are tokens now, so
// they stay in step with the rest of the design system.

const TINT_COUNT = 5;
// Same order as the .avatar--tN rules in index.css, so a name's fill color
// (below) always matches the tint its own avatar renders in.
const TINT_FILLS = ['var(--blue)', 'var(--green)', 'var(--amber)', 'var(--purple)', 'var(--red)'];

function tintIndex(name = '', count = TINT_COUNT) {
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return sum % count;
}

// `count` limits the pick to the first N tints — the navigator's patient list
// uses 4 to leave out the red one, which reads as an alert on a plain row.
export default function avatarTint(name = '', count = TINT_COUNT) {
  return `avatar--t${tintIndex(name, Math.min(count, TINT_COUNT)) + 1}`;
}

// The same per-name tint, but as a solid fill color rather than an
// `.avatar--tN` class — for anything that needs the color itself (a chat
// bubble gradient, a chart line) rather than a background+foreground pair.
export function avatarAccentFill(name = '') {
  return TINT_FILLS[tintIndex(name)];
}
